import type { GatsbyBrowser } from "gatsby";
import React from "react";
import RootElementWrapper from "./src/RootElementWrapper";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => {
  return <RootElementWrapper>{element}</RootElementWrapper>;
};
